export default __webpack_public_path__ + "assets/models/4f73111d5498048f704dc0ad79031ce3.glb";